import request from '../../axios';

export const getLoanTypeDetail = async (loanRequestGuid?: string) => {
  const {data}: {data: ILoanTypeDetailResponse} = await request.get(
    `/api/v2/payment/loan-type-detail/loan-request/` + loanRequestGuid,
  );

  return data;
};
